// extracted by mini-css-extract-plugin
module.exports = {"password-rules":"PasswordRules_password-rules__20iHD"};